import { NumberSymbol } from '@angular/common';

export interface PaymentDocument {
  documentCode: string;
  toCommit: NumberSymbol;
  fiscalYear: string;
}
